// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"4d75bffc","388":"8839c849","396":"80391c54","455":"3a18dc16","977":"09a76e87"}[chunkId] + ".chunk.js";
};